/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Confirm_RegenerateInputs */



/**
* | output |
* | --- |
* | "Regenerate Secret?" |
*
* @param {Developer_Confirm_RegenerateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_confirm_regenerate = /** @type {((inputs?: Developer_Confirm_RegenerateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Confirm_RegenerateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Régénérer le secret ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Regenerar secreto?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regenerar Secret?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rigenerare Secret?")
	return /** @type {LocalizedString} */ ("Regenerate Secret?")
});